import { gql } from "@apollo/client";
import { Def_MutationResponse } from "../../UserCalls/GQLCalls/userCalls";

// CTO todo copy in create
export const CREATE_FEED_CURVE = gql`
  mutation CreateFeedCurve($domain: String!, $name: String!) {
    feedCurve {
      create(domain: $domain, name: $name) {
        code
        success
        message
        updatedValues {
          feedcurve_id
          name
          feedLimit: feed_limit
          passFeed: pass_feed
          stimuli
        }
      }
    }
  }
`;

export interface CreateFeedCurveResponse {
  feedCurve: {
    create: CreateFeedCurve;
  }
}

export interface CreateFeedCurve extends Def_MutationResponse {
    updatedValues: CreateFeedCurveUpdatedValues[]
  }

interface CreateFeedCurveUpdatedValues {
  feedcurve_id: number,
  name: string,
  feedLimit: number,
  passFeed: number,
  stimuli: number
}